'use client';

import { createContext, type ReactNode, useContext, useMemo } from 'react';

import type { RawProjectSettingsApiResponse } from '@campaign-manager/core/model';

interface ProjectSettingsContextValue {
  projectSettings: RawProjectSettingsApiResponse | undefined;
}

const ProjectSettingsContext = createContext<ProjectSettingsContextValue>(
  {} as ProjectSettingsContextValue,
);

interface Props {
  // Accept ProjectSettings from shared LayoutContext or direct RawProjectSettingsApiResponse
  // The actual data at runtime is always RawProjectSettingsApiResponse when not null
  projectSettings: RawProjectSettingsApiResponse | null | undefined;
  children: ReactNode;
}
export function ProjectSettingsProvider({ projectSettings, children }: Props) {
  const value = useMemo(
    () => ({ projectSettings: projectSettings ?? undefined }),
    [projectSettings],
  );

  return (
    <ProjectSettingsContext.Provider value={value}>{children}</ProjectSettingsContext.Provider>
  );
}

export function useProjectSettings() {
  return useContext(ProjectSettingsContext);
}
